import { invokeApig } from './awsLib';
import { isValidUUID } from './isValidUUIDUtility';

export default class Cache {
  constructor(userToken) {
    this.userToken = userToken;

    this.MY_TEAM_ENTITIES_KEY = 'my-team-entities';
    this.MY_TEAMS_KEY = 'my-teams';
    this.ALL_ENTITIES_KEY = 'all-entities-key';
    this.REVIEWERS_KEY = 'reviewers';
    this.REVIEW_TYPES_KEY = 'review-types';
    this.REVIEW_TYPES_EVENT_KEY = 'review-types-event';
    this.LEVELS_OF_CARE_KEY = 'levels-of-care';
    this.STATUS_INDICATORS_KEY = 'status-indicators';
    this.REVIEW_FINDINGS_KEY = 'review-findings';
    this.PHYSICIAN_RESPONSES_KEY = 'physician-responses';
    this.ESCALATION_REASONS_KEY = 'escalation-reasons';
    this.PEER_TO_PEER_OUTCOMES_KEY = 'peer-to-peer-outcomes';
    this.PEER_TO_PEER_ACTIONS_KEY = 'peer-to-peer-actions';
    this.RISK_CATEGORIES = 'risk-categories';
    this.AUTO_ESCALATION_RULES_KEY = 'auto-escalation-rules';
    this.USER_TYPES_KEY = 'user-types';
    this.USER_GUIDE_KEY = 'user-guide';
    this.REVIEW_OUTCOMES = 'review-outcomes';
    this.USER_FACILITIES_KEY = 'user-facilities';
    this.USER_COMBINED_FACILITIES_KEY = 'user-combined-facilities';
    this.USER_FACILITIES_TIMEZONES_KEY = 'user-facilities-timezones';
    this.CUSTOM_POPULATION_SETTING = 'custom-population-setting';
    this.PAYER_TYPES_RR = 'payer-types-rr';
    this.PAYER_NAMES_RR = 'payer-names-rr';
    this.DRAGONFLY_USER_KEY = 'is-dragonfly-user';
    this.APPLICATION_USERS_RR_KEY = 'xpas-application-users-rr';
    this.USER_PROFILE_KEY = 'user-profile';
    this.ENTITY_CONTACTS_KEY = 'entity-contacts';
  }

  clear(username) {
    sessionStorage.removeItem(this.MY_TEAM_ENTITIES_KEY);
    sessionStorage.removeItem(this.MY_TEAMS_KEY);
    sessionStorage.removeItem(this.ALL_ENTITIES_KEY);
    sessionStorage.removeItem(this.REVIEWERS_KEY);
    sessionStorage.removeItem(this.REVIEW_TYPES_KEY);
    sessionStorage.removeItem(this.REVIEW_TYPES_EVENT_KEY);
    sessionStorage.removeItem(this.LEVELS_OF_CARE_KEY);
    sessionStorage.removeItem(this.STATUS_INDICATORS_KEY);
    sessionStorage.removeItem(this.REVIEW_FINDINGS_KEY);
    sessionStorage.removeItem(this.PHYSICIAN_RESPONSES_KEY);
    sessionStorage.removeItem(this.ESCALATION_REASONS_KEY);
    sessionStorage.removeItem(this.PEER_TO_PEER_OUTCOMES_KEY);
    sessionStorage.removeItem(this.PEER_TO_PEER_ACTIONS_KEY);
    sessionStorage.removeItem(this.RISK_CATEGORIES);
    sessionStorage.removeItem(this.AUTO_ESCALATION_RULES_KEY);
    sessionStorage.removeItem(this.USER_TYPES_KEY);
    sessionStorage.removeItem(this.USER_GUIDE_KEY);
    sessionStorage.removeItem(this.REVIEW_OUTCOMES);
    sessionStorage.removeItem(this.USER_FACILITIES_KEY);
    sessionStorage.removeItem(this.USER_COMBINED_FACILITIES_KEY);
    sessionStorage.removeItem(this.USER_FACILITIES_TIMEZONES_KEY);
    sessionStorage.removeItem(this.CUSTOM_POPULATION_SETTING);
    sessionStorage.removeItem(this.PAYER_TYPES_RR);
    sessionStorage.removeItem(this.PAYER_NAMES_RR);
    sessionStorage.removeItem(this.DRAGONFLY_USER_KEY);
    sessionStorage.removeItem(this.APPLICATION_USERS_RR_KEY);
    sessionStorage.removeItem(this.USER_PROFILE_KEY);
    sessionStorage.removeItem(this.ENTITY_CONTACTS_KEY);
    sessionStorage.removeItem(`${this.USER_PROFILE_KEY}-${username}`);
  }

  async getAllForReviews() {
    const results = {
      escalation_reasons: [],
      peer_to_peer_actions: [],
      peer_to_peer_outcomes: [],
      physician_responses: [],
      review_findings: [],
      review_levels_of_care: [],
      review_outcomes: [],
      review_types: [],
      risk_categories: [],
      status_indicators: [],
    };
    if (
      !sessionStorage[this.REVIEW_TYPES_KEY] ||
      !sessionStorage[this.ESCALATION_REASONS_KEY] ||
      !sessionStorage[this.REVIEW_FINDINGS_KEY] ||
      !sessionStorage[this.PHYSICIAN_RESPONSES_KEY] ||
      !sessionStorage[this.STATUS_INDICATORS_KEY] ||
      !sessionStorage[this.PEER_TO_PEER_ACTIONS_KEY] ||
      !sessionStorage[this.PEER_TO_PEER_OUTCOMES_KEY] ||
      !sessionStorage[this.RISK_CATEGORIES] ||
      !sessionStorage[this.LEVELS_OF_CARE_KEY] ||
      !sessionStorage[this.REVIEW_OUTCOMES]
    ) {
      const result = await invokeApig(
        { path: `/types/all-for-reviews`, service: 'USER' },
        this.userToken
      );
      sessionStorage.setItem(
        this.REVIEW_TYPES_KEY,
        JSON.stringify(result.review_types)
      );
      sessionStorage.setItem(
        this.ESCALATION_REASONS_KEY,
        JSON.stringify(result.escalation_reasons)
      );
      sessionStorage.setItem(
        this.REVIEW_FINDINGS_KEY,
        JSON.stringify(result.review_findings)
      );
      sessionStorage.setItem(
        this.PHYSICIAN_RESPONSES_KEY,
        JSON.stringify(result.physician_responses)
      );
      sessionStorage.setItem(
        this.STATUS_INDICATORS_KEY,
        JSON.stringify(result.status_indicators)
      );
      sessionStorage.setItem(
        this.PEER_TO_PEER_ACTIONS_KEY,
        JSON.stringify(result.peer_to_peer_actions)
      );
      sessionStorage.setItem(
        this.PEER_TO_PEER_OUTCOMES_KEY,
        JSON.stringify(result.peer_to_peer_outcomes)
      );
      sessionStorage.setItem(
        this.RISK_CATEGORIES,
        JSON.stringify(result.risk_categories)
      );
      sessionStorage.setItem(
        this.LEVELS_OF_CARE_KEY,
        JSON.stringify(result.review_levels_of_care)
      );
      sessionStorage.setItem(
        this.REVIEW_OUTCOMES,
        JSON.stringify(result.review_outcomes)
      );

      results.review_types = result.review_types;
      results.escalation_reasons = result.escalation_reasons;
      results.review_findings = result.review_findings;
      results.physician_responses = result.physician_responses;
      results.status_indicators = result.status_indicators;
      results.peer_to_peer_actions = result.peer_to_peer_actions;
      results.peer_to_peer_outcomes = result.peer_to_peer_outcomes;
      results.risk_categories = result.risk_categories;
      results.review_levels_of_care = result.review_levels_of_care;
      results.review_outcomes = result.review_outcomes;
    } else {
      results.review_types = JSON.parse(sessionStorage[this.REVIEW_TYPES_KEY]);
      results.escalation_reasons = JSON.parse(
        sessionStorage[this.ESCALATION_REASONS_KEY]
      );
      results.review_findings = JSON.parse(
        sessionStorage[this.REVIEW_FINDINGS_KEY]
      );
      results.physician_responses = JSON.parse(
        sessionStorage[this.PHYSICIAN_RESPONSES_KEY]
      );
      results.status_indicators = JSON.parse(
        sessionStorage[this.STATUS_INDICATORS_KEY]
      );
      results.peer_to_peer_actions = JSON.parse(
        sessionStorage[this.PEER_TO_PEER_ACTIONS_KEY]
      );
      results.peer_to_peer_outcomes = JSON.parse(
        sessionStorage[this.PEER_TO_PEER_OUTCOMES_KEY]
      );
      results.risk_categories = JSON.parse(
        sessionStorage[this.RISK_CATEGORIES]
      );
      results.review_levels_of_care = JSON.parse(
        sessionStorage[this.LEVELS_OF_CARE_KEY]
      );
      results.review_outcomes = JSON.parse(
        sessionStorage[this.REVIEW_OUTCOMES]
      );
    }

    return results;
  }

  async getTeamEntities() {
    if (sessionStorage[this.MY_TEAM_ENTITIES_KEY]) {
      return JSON.parse(sessionStorage[this.MY_TEAM_ENTITIES_KEY]);
    } else {
      const result = await invokeApig(
        { path: `/users/assigned-entities`, service: 'USER' },
        this.userToken
      );
      const entities = result.entities.sort((a, b) => {
        return a.entity_name.localeCompare(b.entity_name);
      });
      sessionStorage.setItem(
        this.MY_TEAM_ENTITIES_KEY,
        JSON.stringify(entities)
      );
      return result.entities;
    }
  }

  async getTeams() {
    if (sessionStorage[this.MY_TEAMS_KEY]) {
      return JSON.parse(sessionStorage[this.MY_TEAMS_KEY]);
    } else {
      const result = await invokeApig(
        { MY_TEAMS_KEY: 'USER', path: `/types/my-teams` },
        this.userToken
      );
      sessionStorage.setItem(this.MY_TEAMS_KEY, JSON.stringify(result.types));
      return result.types;
    }
  }

  async getAllEntities() {
    if (sessionStorage[this.ALL_ENTITIES_KEY]) {
      return JSON.parse(sessionStorage[this.ALL_ENTITIES_KEY]);
    } else {
      const result = await invokeApig(
        { path: `/types/entities`, service: 'TYPES' },
        this.userToken
      );
      const entities = result.types.sort((a, b) => {
        return a.entity_name.localeCompare(b.entity_name);
      });
      sessionStorage.setItem(this.ALL_ENTITIES_KEY, JSON.stringify(entities));
      return result.types;
    }
  }

  async getReviewers() {
    if (sessionStorage[this.REVIEWERS_KEY]) {
      return JSON.parse(sessionStorage[this.REVIEWERS_KEY]);
    } else {
      const result = await invokeApig(
        { path: `/users/teammates/abilities/reviewers`, service: 'USER' },
        this.userToken
      );
      sessionStorage.setItem(this.REVIEWERS_KEY, JSON.stringify(result.users));
      return result.users;
    }
  }

  async getReviewersNoCache() {
    const result = await invokeApig(
      { path: `/users/teammates/abilities/reviewers`, service: 'USER' },
      this.userToken
    );
    return result.users;
  }

  async getApplicationUsersRR() {
    if (sessionStorage[this.APPLICATION_USERS_RR_KEY]) {
      return JSON.parse(sessionStorage[this.APPLICATION_USERS_RR_KEY]);
    } else {
      const result = await invokeApig(
        { path: '/users/application-users/xpas', service: 'USER' },
        this.userToken
      );
      sessionStorage.setItem(
        this.APPLICATION_USERS_RR_KEY,
        JSON.stringify(result.users)
      );
      return result.users;
    }
  }

  async getReviewTypes() {
    if (sessionStorage[this.REVIEW_TYPES_KEY]) {
      return JSON.parse(sessionStorage[this.REVIEW_TYPES_KEY]);
    } else {
      const result = await invokeApig(
        { path: `/types/review-types`, service: 'TYPES' },
        this.userToken
      );
      sessionStorage.setItem(
        this.REVIEW_TYPES_KEY,
        JSON.stringify(result.types)
      );
      return result.types;
    }
  }

  async getEventReviewTypes() {
    if (sessionStorage[this.REVIEW_TYPES_EVENT_KEY]) {
      return JSON.parse(sessionStorage[this.REVIEW_TYPES_EVENT_KEY]);
    } else {
      const result = await invokeApig(
        { path: `/types/review-types-rr`, service: 'TYPES' },
        this.userToken
      );
      sessionStorage.setItem(
        this.REVIEW_TYPES_EVENT_KEY,
        JSON.stringify(result.types)
      );
      return result.types;
    }
  }

  async getUserFacilities(username) {
    if (sessionStorage[this.USER_FACILITIES_KEY + '-' + username]) {
      return JSON.parse(
        sessionStorage[this.USER_FACILITIES_KEY + '-' + username]
      );
    } else {
      const result = await invokeApig({
        path: `/users/teams/entities/${username}`,
        service: 'USER',
      });
      sessionStorage.setItem(
        this.USER_FACILITIES_KEY + '-' + username,
        JSON.stringify(result.entities)
      );
      return result.entities;
    }
  }

  async getUserFacilitiesRR(username) {
    if (sessionStorage[this.USER_FACILITIES_KEY + '-' + username]) {
      return JSON.parse(
        sessionStorage[this.USER_FACILITIES_KEY + '-' + username]
      );
    } else {
      const result = await invokeApig({
        path: `/users/application-user/teams`,
        service: 'USER',
      });
      sessionStorage.setItem(
        this.USER_FACILITIES_KEY + '-' + username,
        JSON.stringify(result.entities)
      );
      return result.entities;
    }
  }

  async getUserCombinedFacilities(username, isDragonfly, pamConnectionEnabled) {
    const merlotRequest = async (username) => {
      return await invokeApig({
        path: `/users/teams/entities/${username}`,
        service: 'USER',
      });
    };
    const dragonflyRequest = async () => {
      return await invokeApig({
        path: `/users/application-user/teams`,
        service: 'USER',
      });
    };
    if (sessionStorage[this.USER_COMBINED_FACILITIES_KEY]) {
      return JSON.parse(sessionStorage[this.USER_COMBINED_FACILITIES_KEY]);
    } else if (isDragonfly) {
      if (pamConnectionEnabled) {
        const [merlotResult, dragonflyResult] = await Promise.all([
          merlotRequest(username),
          dragonflyRequest(),
        ]);
        const combinedResults = [
          ...merlotResult.entities,
          ...dragonflyResult.entities,
        ];
        sessionStorage.setItem(
          this.USER_COMBINED_FACILITIES_KEY,
          JSON.stringify(combinedResults)
        );
        return combinedResults;
      } else {
        const dragonflyResult = await dragonflyRequest();
        sessionStorage.setItem(
          this.USER_COMBINED_FACILITIES_KEY,
          JSON.stringify(dragonflyResult.entities)
        );
        return dragonflyResult.entities;
      }
    } else {
      const merlotResult = await merlotRequest(username);
      sessionStorage.setItem(
        this.USER_COMBINED_FACILITIES_KEY,
        JSON.stringify(merlotResult.entities)
      );
      return merlotResult.entities;
    }
  }

  async getUserFacilitiesTimezones(facilities) {
    if (!facilities) {
      return [];
    }

    if (sessionStorage[this.USER_FACILITIES_TIMEZONES_KEY]) {
      return JSON.parse(sessionStorage[this.USER_FACILITIES_TIMEZONES_KEY]);
    } else {
      const merlotFacilities = facilities.filter(
        (facility) => !isValidUUID(facility.entity_id)
      );
      const dragonflyFacilities = facilities.filter((facility) =>
        isValidUUID(facility.entity_id)
      );

      const facilityTimezones = [];

      if (merlotFacilities.length) {
        const mfIds = [];
        merlotFacilities.forEach((facility) => mfIds.push(facility.entity_id));

        const response = await invokeApig({
          body: {
            facilityIds: mfIds,
          },
          method: 'POST',
          path: '/entity/merlot-timezones',
          service: 'ENTITIES',
        });

        if (response && response.facilities) {
          response.facilities.forEach((facility) => {
            if (facility) {
              facilityTimezones.push(facility);
            }
          });
        }
      }

      if (dragonflyFacilities.length) {
        const dfIds = [];
        dragonflyFacilities.forEach((facility) =>
          dfIds.push(facility.entity_id)
        );

        const response = await invokeApig({
          body: {
            facilityIds: dfIds,
          },
          method: 'POST',
          path: '/entity/dragonfly-timezones',
          service: 'ENTITIES',
        });

        if (response && response.facilities) {
          response.facilities.forEach((facility) =>
            facilityTimezones.push(facility)
          );
        }
      }

      sessionStorage.setItem(
        this.USER_FACILITIES_TIMEZONES_KEY,
        JSON.stringify(facilityTimezones)
      );
      return facilityTimezones;
    }
  }

  async getLevelsOfCare() {
    if (sessionStorage[this.LEVELS_OF_CARE_KEY]) {
      return JSON.parse(sessionStorage[this.LEVELS_OF_CARE_KEY]);
    } else {
      const result = await invokeApig(
        { path: `/types/review-levels-of-care`, service: 'TYPES' },
        this.userToken
      );
      sessionStorage.setItem(
        this.LEVELS_OF_CARE_KEY,
        JSON.stringify(result.types)
      );
      return result.types;
    }
  }

  async getStatusIndicators() {
    if (sessionStorage[this.STATUS_INDICATORS_KEY]) {
      return JSON.parse(sessionStorage[this.STATUS_INDICATORS_KEY]);
    } else {
      const result = await invokeApig(
        { path: `/types/status-indicators`, service: 'TYPES' },
        this.userToken
      );
      sessionStorage.setItem(
        this.STATUS_INDICATORS_KEY,
        JSON.stringify(result.types)
      );
      return result.types;
    }
  }

  async getReviewFindings() {
    if (sessionStorage[this.REVIEW_FINDINGS_KEY]) {
      return JSON.parse(sessionStorage[this.REVIEW_FINDINGS_KEY]);
    } else {
      const result = await invokeApig(
        { path: `/types/review-findings`, service: 'TYPES' },
        this.userToken
      );
      sessionStorage.setItem(
        this.REVIEW_FINDINGS_KEY,
        JSON.stringify(result.types)
      );
      return result.types;
    }
  }

  async getPhysicianResponses() {
    if (sessionStorage[this.PHYSICIAN_RESPONSES_KEY]) {
      return JSON.parse(sessionStorage[this.PHYSICIAN_RESPONSES_KEY]);
    } else {
      const result = await invokeApig(
        { path: `/types/physician-responses`, service: 'TYPES' },
        this.userToken
      );
      sessionStorage.setItem(
        this.PHYSICIAN_RESPONSES_KEY,
        JSON.stringify(result.types)
      );
      return result.types;
    }
  }

  async getEscalationReasons() {
    if (sessionStorage[this.ESCALATION_REASONS_KEY]) {
      return JSON.parse(sessionStorage[this.ESCALATION_REASONS_KEY]);
    } else {
      const result = await invokeApig(
        { path: `/types/escalation-reasons`, service: 'TYPES' },
        this.userToken
      );
      sessionStorage.setItem(
        this.ESCALATION_REASONS_KEY,
        JSON.stringify(result.types)
      );
      return result.types;
    }
  }

  async getPeerToPeerOutcomes() {
    if (sessionStorage[this.PEER_TO_PEER_OUTCOMES_KEY]) {
      return JSON.parse(sessionStorage[this.PEER_TO_PEER_OUTCOMES_KEY]);
    } else {
      const result = await invokeApig(
        { path: `/types/peer-to-peer-outcomes`, service: 'TYPES' },
        this.userToken
      );
      sessionStorage.setItem(
        this.PEER_TO_PEER_OUTCOMES_KEY,
        JSON.stringify(result.types)
      );
      return result.types;
    }
  }

  async getPeerToPeerActions() {
    if (sessionStorage[this.PEER_TO_PEER_ACTIONS_KEY]) {
      return JSON.parse(sessionStorage[this.PEER_TO_PEER_ACTIONS_KEY]);
    } else {
      const result = await invokeApig(
        { path: `/types/peer-to-peer-actions`, service: 'TYPES' },
        this.userToken
      );
      sessionStorage.setItem(
        this.PEER_TO_PEER_ACTIONS_KEY,
        JSON.stringify(result.types)
      );
      return result.types;
    }
  }

  async getRiskCategories() {
    if (sessionStorage[this.RISK_CATEGORIES]) {
      return JSON.parse(sessionStorage[this.RISK_CATEGORIES]);
    } else {
      const result = await invokeApig(
        { path: `/types/risk-categories`, service: 'TYPES' },
        this.userToken
      );
      sessionStorage.setItem(
        this.RISK_CATEGORIES,
        JSON.stringify(result.types)
      );
      return result.types;
    }
  }

  async getAutoEscalationRules() {
    if (sessionStorage[this.AUTO_ESCALATION_RULES_KEY]) {
      return JSON.parse(sessionStorage[this.AUTO_ESCALATION_RULES_KEY]);
    } else {
      const result = await invokeApig(
        { path: `/types/auto-escalation-rules`, service: 'TYPES' },
        this.userToken
      );
      sessionStorage.setItem(
        this.AUTO_ESCALATION_RULES_KEY,
        JSON.stringify(result.types)
      );
      return result.types;
    }
  }

  async getUserTypes() {
    if (sessionStorage[this.USER_TYPES_KEY]) {
      return JSON.parse(sessionStorage[this.USER_TYPES_KEY]).sort((a, b) =>
        a.description.localeCompare(b.description)
      );
    } else {
      const result = await invokeApig(
        { path: `/types/user-types`, service: 'TYPES' },
        this.userToken
      );
      sessionStorage.setItem(this.USER_TYPES_KEY, JSON.stringify(result.types));
      return result.types.sort((a, b) =>
        a.description.localeCompare(b.description)
      );
    }
  }

  async getUserGuide() {
    // signed urls expire, so implement some client side expiration here as well
    if (sessionStorage[this.USER_GUIDE_KEY]) {
      const item = JSON.parse(sessionStorage[this.USER_GUIDE_KEY]);
      const dateCheck = new Date(item.exp);

      if (dateCheck > new Date()) {
        return item.url;
      }
    }

    const result = await invokeApig({ path: `/user-guide` }, this.userToken);
    const expDate = new Date();
    expDate.setHours(expDate.getHours() + 60);

    const item = {
      exp: expDate,
      url: result.url,
    };
    sessionStorage.setItem(this.USER_GUIDE_KEY, JSON.stringify(item));
    return result.url;
  }

  async getReviewOutcomes() {
    if (sessionStorage[this.REVIEW_OUTCOMES]) {
      return JSON.parse(sessionStorage[this.REVIEW_OUTCOMES]);
    } else {
      const result = await invokeApig(
        { path: `/types/review-outcomes`, service: 'TYPES' },
        this.userToken
      );
      sessionStorage.setItem(
        this.REVIEW_OUTCOMES,
        JSON.stringify(result.types)
      );
      return result.types;
    }
  }

  async getCustomPopulationSetting(settingName) {
    if (sessionStorage[this.CUSTOM_POPULATION_SETTING + '_' + settingName]) {
      return JSON.parse(
        sessionStorage[this.CUSTOM_POPULATION_SETTING + '_' + settingName]
      );
    } else {
      const result = await invokeApig(
        {
          path: `/custom-population/settings/${settingName}`,
          service: 'CUSTOM-POPULATION',
        },
        this.userToken
      );
      sessionStorage.setItem(
        this.CUSTOM_POPULATION_SETTING + '_' + settingName,
        JSON.stringify(result.settingValues)
      );
      return result.settingValues;
    }
  }

  async getPayerTypesRR() {
    const storageKey = this.PAYER_TYPES_RR;
    try {
      const cachedData = sessionStorage.getItem(storageKey);
      if (cachedData) return JSON.parse(cachedData);
    } catch {
      sessionStorage.removeItem(storageKey);
    }

    const result = await invokeApig({
      path: '/custom-population-rr/payer-types',
      service: 'TYPES',
    });

    sessionStorage.setItem(storageKey, JSON.stringify(result));
    return result;
  }

  async getPayerNamesRR() {
    if (sessionStorage[this.PAYER_NAMES_RR]) {
      return JSON.parse(sessionStorage[this.PAYER_NAMES_RR]);
    } else {
      const result = await invokeApig({
        path: '/custom-population-rr/payer-names',
        service: 'TYPES',
      });
      sessionStorage.setItem(
        this.PAYER_NAMES_RR,
        JSON.stringify(result.entities)
      );
      return result.entities;
    }
  }

  async getEntityContacts(entityId) {
    const storageKey = `${this.ENTITY_CONTACTS_KEY}-${entityId}`;
    if (sessionStorage[storageKey]) {
      return JSON.parse(sessionStorage[storageKey]);
    } else {
      const result = await invokeApig({
        path: `/entities/${entityId}/contacts`,
      });
      sessionStorage.setItem(
        storageKey,
        JSON.stringify(result.entity_contacts)
      );
      return result.entity_contacts;
    }
  }

  async getApplicationUserRR(username) {
    const encodedUsername = encodeURIComponent(username);
    if (sessionStorage[`${this.USER_PROFILE_KEY}-${username}`]) {
      return JSON.parse(sessionStorage[`${this.USER_PROFILE_KEY}-${username}`]);
    } else {
      const response = await invokeApig({
        path: `/users/xlate-email?xpas_username=${encodedUsername}`,
        service: 'USER',
      });
      const responseBoolean = Boolean(response.id);
      if (response?.application_user_id) {
        sessionStorage.setItem(
          `${this.USER_PROFILE_KEY}-${username}`,
          JSON.stringify(response)
        );
        return response;
      } else if (responseBoolean) {
        let dfResponse;
        if (responseBoolean) {
          dfResponse = await invokeApig({
            path: `/users/application-user`,
            service: 'USER',
          });
        }
        let userProfile = {};
        if (dfResponse) {
          userProfile = { ...dfResponse.user, id: response.id.RR_ID };
          sessionStorage.setItem(
            `${this.USER_PROFILE_KEY}-${username}`,
            JSON.stringify(userProfile)
          );
          return userProfile;
        }
      }
    }
  }
}
